export default __webpack_public_path__ + "static/media/ring.50e42461.mp3";